





















import { isEqual } from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardCommon from "../../components/cards/CardCommon.vue";
import { IServiceType, IServiceTypePriceReverseOptionalData } from "../../entities";
import { ILink } from "../lib/models";

@Component({
  components: {
    CardCommon,
  },
})
export default class ServicePreviewCard extends Vue {
  @Prop() readonly data!: IServiceType;
  @Prop({ default: 1 }) readonly index?: number;

  get link(): ILink {
    return {
      label: this.$t("links." + this.data.type + "-short") as string,
      ref: "Modal" + this.$options.filters?.camelCase(this.data.type),
    };
  }

  get desc(): string {
    let special = this.data.special;
    return this.data.description + "";
  }

  private openLink(link: ILink, linkName: string): void {
    //
    if (isEqual(link.ref, 'ModalPlanPublic')) {
      // browse all travels
      this.$store.dispatch('setTravelFormatRequest', 'single');
      this.$router.push({ name: "Travels" });
      return;
    }
    // if (isEqual(link.ref, 'ModalService')) {
    //   const typeTravel: string = linkName.includes('Индивидуальные')
    //                               || linkName.includes('Individual') ?
    //                               'individual' : 'group';

    //   this.$store.dispatch('setTravelFormatRequest', typeTravel);
    //   this.$router.push({ path: 'travels' });
    //   return;
    // }
    else {
      // open modal with subject
      let prices = this.data.prices;
      let id = this.data.id
      let subject: IServiceTypePriceReverseOptionalData = {
        ...(prices.length === 1 ? prices[0] : {id}),
        service_type: this.data,
      };
      this.$storage.actions.setModal({
        name: link.ref,
        subject: subject,
        from: "preview",
      });
    }
  }
}
